const PUSH_PERMISSIONS_STORAGE_KEY = "@SAC_RPE_PUSH_PERMISSIONS";

type PushFeature = {
  push?: boolean;
  sac?: boolean;
  functionDetails?: { name?: string; slug?: string; active?: boolean };
};

const readPushFeatures = (): PushFeature[] | null => {
  const rawData = sessionStorage.getItem(PUSH_PERMISSIONS_STORAGE_KEY);
  if (!rawData) return null;

  const permissions = JSON.parse(rawData);
  const { apiData } = permissions;
  if (!Array.isArray(apiData)) return null;

  return apiData;
};

const matchesFunctionName = (item: PushFeature, functionName: string) =>
  item?.functionDetails?.slug === functionName ||
  item?.functionDetails?.name === functionName;

const channelIsEnabled = (featureData: PushFeature, channel: "push" | "sac") => {
  const functionActive = featureData.functionDetails?.active as
    | boolean
    | number
    | undefined;
  const functionIsInactive = functionActive === false || functionActive === 0;

  if (functionIsInactive && channel === "push") return false;
  if (functionIsInactive && channel === "sac") return true;

  return !!featureData[channel];
};

export const hasPushPermission = (
  functionName: string,
  channel: "push" | "sac"
): boolean => {
  const sacAllowedWithoutPushConfig = channel === "sac";

  try {
    const apiData = readPushFeatures();
    if (!apiData) return sacAllowedWithoutPushConfig;

    const featureData = apiData.find((item) =>
      matchesFunctionName(item, functionName)
    );

    if (!featureData) return sacAllowedWithoutPushConfig;

    return channelIsEnabled(featureData, channel);
  } catch (error) {
    console.error("Erro na validação de permissão push:", error);
    return channel === "sac";
  }
};

export const hasMatchingPushPermission = (
  functionNames: readonly string[],
  channel: "push" | "sac"
): boolean => {
  try {
    const apiData = readPushFeatures();
    if (!apiData) return channel === "sac";

    const featureData = apiData.find((item) =>
      functionNames.some((functionName) => matchesFunctionName(item, functionName))
    );

    if (!featureData) return channel === "sac";

    return channelIsEnabled(featureData, channel);
  } catch (error) {
    console.error("Erro na validação de permissão push:", error);
    return channel === "sac";
  }
};

export { PUSH_PERMISSIONS_STORAGE_KEY };
